(() => {
  if (window.__luxeEditorialBound) {
    window.__luxeEditorialPaint?.();
    return;
  }
  window.__luxeEditorialBound = true;
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const WISH_KEY = "luxe-wishlist";

  const readWish = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(WISH_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const writeWish = (items) => {
    localStorage.setItem(WISH_KEY, JSON.stringify(items));
    paintWish();
  };

  const esc = (value) =>
    String(value ?? "").replace(/[&<>"']/g, (char) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char])
    );

  const paintWish = () => {
    const items = readWish();
    document.querySelectorAll("[data-lx-wish]").forEach((button) => {
      const saved = items.some((item) => item.handle === button.dataset.handle);
      button.classList.toggle("is-saved", saved);
      button.setAttribute("aria-pressed", saved ? "true" : "false");
    });
    document.querySelectorAll("[data-lx-wish-count]").forEach((node) => {
      if (items.length) {
        node.hidden = false;
        node.textContent = String(items.length);
      } else {
        node.hidden = true;
        node.textContent = "";
      }
    });
    document.querySelectorAll("[data-lx-wish-list]").forEach((list) => {
      if (!items.length) {
        list.innerHTML = '<p class="lx-empty">Nothing saved yet. Use the heart on a piece to keep it on this browser.</p>';
        return;
      }
      list.innerHTML = `<ul class="lx-wish-items">${items
        .map(
          (item) => `<li>
            <a href="${esc(item.url)}">
              ${item.image ? `<img src="${esc(item.image)}" alt="" width="72" height="90">` : ""}
              <span><strong>${esc(item.title)}</strong><em>${esc(item.price || "")}</em></span>
            </a>
            <button type="button" data-lx-wish-remove="${esc(item.handle)}">Remove</button>
          </li>`
        )
        .join("")}</ul>`;
    });
  };

  const openDialog = (name) => {
    const dialog = document.querySelector(`[data-lx-dialog="${name}"]`);
    if (!dialog || typeof dialog.showModal !== "function") return;
    if (!dialog.open) dialog.showModal();
    document.querySelectorAll(`[data-lx-open="${name}"]`).forEach((button) => {
      button.setAttribute("aria-expanded", "true");
    });
  };

  const closeDialog = (dialog) => {
    if (dialog?.open) dialog.close();
  };

  document.addEventListener("click", (event) => {
    const open = event.target.closest("[data-lx-open]");
    if (open) {
      event.preventDefault();
      openDialog(open.dataset.lxOpen);
      return;
    }

    const close = event.target.closest("[data-lx-close]");
    if (close) {
      close.closest("dialog")?.close();
      return;
    }

    const wish = event.target.closest("[data-lx-wish]");
    if (wish) {
      event.preventDefault();
      event.stopPropagation();
      const handle = wish.dataset.handle;
      if (!handle) return;
      const items = readWish();
      const index = items.findIndex((item) => item.handle === handle);
      if (index >= 0) items.splice(index, 1);
      else {
        items.unshift({
          handle,
          title: wish.dataset.title || handle,
          url: wish.dataset.url || `/products/${handle}`,
          image: wish.dataset.image || "",
          price: wish.dataset.price || "",
        });
      }
      writeWish(items.slice(0, 30));
      return;
    }

    const remove = event.target.closest("[data-lx-wish-remove]");
    if (remove) {
      const handle = remove.dataset.lxWishRemove;
      writeWish(readWish().filter((item) => item.handle !== handle));
      return;
    }

    const prev = event.target.closest("[data-lx-scroll-prev]");
    const next = event.target.closest("[data-lx-scroll-next]");
    const scrollButton = prev || next;
    if (scrollButton) {
      const track = document.querySelector(scrollButton.dataset.lxScrollPrev || scrollButton.dataset.lxScrollNext);
      if (!track) return;
      const card = track.querySelector(".lx-card");
      const delta = (card?.getBoundingClientRect().width || 320) + 16;
      track.scrollBy({ left: prev ? -delta : delta, behavior: reduced ? "auto" : "smooth" });
    }
  });

  document.querySelectorAll("[data-lx-dialog]").forEach((dialog) => {
    dialog.addEventListener("close", () => {
      document.querySelectorAll(`[data-lx-open="${dialog.dataset.lxDialog}"]`).forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });
    });
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  const showHero = (hero, nextIndex) => {
    const slides = [...hero.querySelectorAll("[data-lx-slide]")];
    if (!slides.length) return;
    const index = (nextIndex + slides.length) % slides.length;
    hero.dataset.lxIndex = String(index);
    hero.dataset.lxLast = String(Date.now());
    slides.forEach((slide, slideIndex) => slide.classList.toggle("is-active", slideIndex === index));
    const label = hero.querySelector("[data-lx-hero-index]");
    const caption = hero.querySelector("[data-lx-hero-caption]");
    if (label) label.textContent = String(index + 1).padStart(2, "0");
    if (caption) caption.textContent = slides[index].dataset.caption || "";
  };

  document.querySelectorAll("[data-lx-hero]").forEach((hero) => showHero(hero, Number(hero.dataset.lxIndex || 0)));

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-lx-hero-prev], [data-lx-hero-next]");
    if (!button) return;
    const hero = button.closest("[data-lx-hero]");
    if (!hero) return;
    const current = Number(hero.dataset.lxIndex || 0);
    showHero(hero, button.hasAttribute("data-lx-hero-prev") ? current - 1 : current + 1);
  });

  if (!reduced) {
    window.setInterval(() => {
      document.querySelectorAll("[data-lx-hero]").forEach((hero) => {
        if (hero.dataset.lxPaused === "true") return;
        if (hero.querySelectorAll("[data-lx-slide]").length < 2) return;
        const delay = Number(hero.dataset.interval || 7) * 1000;
        if (Date.now() - Number(hero.dataset.lxLast || 0) < delay) return;
        showHero(hero, Number(hero.dataset.lxIndex || 0) + 1);
      });
    }, 1000);
    document.addEventListener("mouseover", (event) => {
      const hero = event.target.closest?.("[data-lx-hero]");
      if (hero) hero.dataset.lxPaused = "true";
    });
    document.addEventListener("mouseout", (event) => {
      const hero = event.target.closest?.("[data-lx-hero]");
      if (hero && !hero.contains(event.relatedTarget)) hero.dataset.lxPaused = "false";
    });
    document.addEventListener("focusin", (event) => {
      const hero = event.target.closest?.("[data-lx-hero]");
      if (hero) hero.dataset.lxPaused = "true";
    });
    document.addEventListener("focusout", (event) => {
      const hero = event.target.closest?.("[data-lx-hero]");
      if (hero && !hero.contains(event.relatedTarget)) hero.dataset.lxPaused = "false";
    });
  }

  const selectTab = (tab) => {
    const tablist = tab.closest(".lx-tabs");
    const section = tab.closest(".lx-pieces");
    const tabs = [...(tablist?.querySelectorAll("[data-lx-tab]") || [])];
    tabs.forEach((item, index) => {
      const active = item === tab;
      item.classList.toggle("is-active", active);
      item.setAttribute("aria-selected", active ? "true" : "false");
      item.tabIndex = active ? 0 : index === 0 && !tabs.some((candidate) => candidate.classList.contains("is-active")) ? 0 : -1;
      if (active) item.tabIndex = 0;
      else item.tabIndex = -1;
    });
    section?.querySelectorAll(".lx-panel").forEach((panel) => {
      const active = panel.id === `LxPanel-${tab.dataset.lxTab}`;
      panel.classList.toggle("is-active", active);
      panel.hidden = !active;
    });
  };

  document.addEventListener("click", (event) => {
    const tab = event.target.closest("[data-lx-tab]");
    if (tab) selectTab(tab);
  });
  document.addEventListener("keydown", (event) => {
    const tab = event.target.closest?.("[data-lx-tab]");
    if (!tab || (event.key !== "ArrowRight" && event.key !== "ArrowLeft")) return;
    const tabs = [...tab.closest(".lx-tabs").querySelectorAll("[data-lx-tab]")];
    const index = tabs.indexOf(tab);
    const direction = event.key === "ArrowRight" ? 1 : -1;
    const next = tabs[(index + direction + tabs.length) % tabs.length];
    event.preventDefault();
    next.focus();
    selectTab(next);
  });

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-lx-hero]").forEach((hero) => showHero(hero, 0));
    paintWish();
  });

  window.LuxeEditorial = { paintWish };
  window.__luxeEditorialPaint = paintWish;
  paintWish();
})();
